export default [
  {
    type:'INTEGER',
    name:'Integer',
    default: 1,
  },
  {
    type:'STRING',
    name:'String',
    default: 'String',
  },
  {
    type:'TIMER',
    name:'Timer',
    default: 'Timer',
  },
]